import { useForm } from 'react-hook-form';

import { TProductionCenterForm } from '../types';

export function useProductionCenterDrawerFormState() {
  const initialValues: Partial<TProductionCenterForm> = {
    name: '',
    description: '',
  };
  const form = useForm<TProductionCenterForm>({
    mode: 'all',
    defaultValues: initialValues,
  });

  return { form, initialValues };
}
